import React from 'react'
import Bredcom from '../Bredcom/Main'
import First from '../Menblog-deatils/First'

function Main() {
  return (
    <>
        <Bredcom title="Blog Deatils" subtitle="Home" subtitledown="Blog Deatils" />
        <First/>
    </>
  )
}

export default Main